export var APP_NAME = 'Scan Delivery';
export var ID_TOKEN_COOKIE = 'idToken';